"use client"

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { AccountSettingsTab } from "./account-settings-tab"
import { LoginSecurityTab } from "./login-security-tab"
import { NotificationsTab } from "./notifications-tab"
import { AdditionalSettingsTab } from "./additional-settings-tab"

export function SettingsTabs() {
  return (
    <Tabs defaultValue="account" className="w-full">
      <TabsList className="grid w-full grid-cols-4 gap-2 bg-muted p-1">
        <TabsTrigger
          value="account"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Account Settings
        </TabsTrigger>
        <TabsTrigger
          value="security"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Login & Security
        </TabsTrigger>
        <TabsTrigger
          value="notifications"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Notifications
        </TabsTrigger>
        <TabsTrigger
          value="additional"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Additional
        </TabsTrigger>
      </TabsList>

      <TabsContent value="account" className="mt-6">
        <AccountSettingsTab />
      </TabsContent>

      <TabsContent value="security" className="mt-6">
        <LoginSecurityTab />
      </TabsContent>

      <TabsContent value="notifications" className="mt-6">
        <NotificationsTab />
      </TabsContent>

      <TabsContent value="additional" className="mt-6">
        <AdditionalSettingsTab />
      </TabsContent>
    </Tabs>
  )
}
